import { StoreContext } from './store.context';
import React, { FC, ReactNode, useContext, useMemo } from 'react';
import { RootStore } from './root.store';
import { ContactType } from '../domains/common.domain';

export const StoreProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const store = useMemo(() => {
    const rootStore = new RootStore();
    rootStore.init();
    return rootStore;
  }, []);

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};

export const useStore = () => {
  const context = useContext(StoreContext);

  if (context === undefined) {
    throw new Error('useStore must be used within StoreProvider');
  }

  return context;
};

export const useContactsStore = (contactsType: ContactType) => {
  const { onboardingContactsStore, adminContactStore, shippingContactStore, billingContactsStore } = useStore();
  const storeMap = {
    onboarding: onboardingContactsStore,
    admin: adminContactStore,
    shipping: shippingContactStore,
    billing: billingContactsStore,
  };

  return { contactsStore: storeMap[contactsType] };
};
